// extracted by mini-css-extract-plugin
export default {"restrictions":"ProviderGeoRestrictionsCell_restrictions__FXrJI","code":"ProviderGeoRestrictionsCell_code__JbJZv","more":"ProviderGeoRestrictionsCell_more__DX+LO"};